<template>
  <j-modal
    :title="title"
    width="25%"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    :body-style="{ height: '580px', overflow: 'hidden', overflowY: 'scroll' }"
    @ok="handleOk"
    @cancel="handleCancel"
    :okText="$t('确定')"
    :cancelText="$t('关闭')"
    :okButtonProps="{ class: { 'jee-hidden': disableSubmit } }"
  >
    <a-spin :spinning="confirmLoading">
      <j-form-container :disabled="disableSubmit">
        <a-form-model
          ref="form"
          :model="model"
          :rules="validatorRules"
          slot="detail"
          :colon="true"
          layout="horizontal"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
        >
          <a-row :gutter="24">
            <a-col :span="24" v-for="(value, key, index) in model" :key="index">
              <a-form-model-item :label="setLabel(key)" :prop="key" v-if="setIsShow(key)">
                <!-- DMA标记：使用开关 -->
                <a-switch
                  :checked="!!model[key]"
                  @change="(val) => { model[key] = val ? 1 : 0 }"
                  :disabled="setDisabled(key)"
                  :checked-children="$t('是')"
                  :un-checked-children="$t('否')"
                  v-if="key == 'dmaFlag'"
                />
                <!-- 节点类型：使用字典选择 -->
                <j-dict-select-tag 
                  :showSearch="false" 
                  v-model="model[key]" 
                  :placeholder="$t('请选择类型')" 
                  :disabled="setDisabled(key)" 
                  dictCode="node_type" 
                  v-else-if="key == 'type'"
                />
                <!-- 其他字段：使用输入框 -->
                <a-input 
                  v-model="model[key]" 
                  :placeholder="$t('请输入')" 
                  :disabled="setDisabled(key)" 
                  v-else
                />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
  </j-modal>
</template>
  
  <script>
import { httpAction, getAction, postAction } from '@/api/manage'
import { validateDuplicateValue } from '@/utils/util'
import JSearchSelectTag from '../../../../../components/dict/JSearchSelectTag.vue'
import JDictSelectTag from '../../../../../components/dict/JDictSelectTag.vue'
import CONFIG from '@/views/DMAPartitionMetering/PipelineNetMap/module/config/GIS_Config'
export default {
  name: 'modal',
  components: { JSearchSelectTag, JDictSelectTag },
  data() {
    return {
      title: this.$t('节点属性编辑'),
      width: 800,
      visible: false,
      disableSubmit: false,
      confirmLoading: false,
      model: {},
      validatorRules: {},
      isEdit: false, // 是否为编辑模式
      editFromList: false, // 是否从列表打开的编辑
      operationType: 'edit', // 操作类型：edit(编辑草稿) 或 updateApply(更新申请)
      url: {
        getNodeByCode: '/jeecg-gis/topology/node/getNodeByCode',
        addNode: '/jeecg-gis/topology/node/createNode', // 新增节点接口
        updateNode: "/jeecg-gis/topology/node/updateNode", // 原编辑接口（地图编辑使用）
        updateDraft: "/jeecg-gis/topology/node/updateDraft" // 草稿编辑接口（列表编辑使用）
      },
      labelCol: { span: 5 },
      wrapperCol: { span: 19 },
    }
  },
  computed: {
    // 字段映射字典（中文标签）
    fieldLabels() {
      return {
        projectCode: this.$t('项目编码'),
        topologyCode: this.$t('拓扑编码'),
        code: this.$t('节点编码'),
        name: this.$t('节点名称'),
        type: this.$t('节点类型'),
        height: this.$t('高程'),
        dmaFlag: this.$t('DMA标记'),
        zoomLevel: this.$t('层级'),
        x: this.$t('X坐标'),
        y: this.$t('Y坐标'),
      }
    },
  },
  methods: {
    init(row, editFromList = false) {
      this.visible = true
      this.confirmLoading = true
      this.editFromList = editFromList // 标记是否从列表打开
      
      // 判断是新增还是编辑模式
      if (row.code) {
        // 编辑模式：请求节点详细信息
        this.isEdit = true
        this.title = this.$t('编辑节点')
        
        let params = {
          projectCode: CONFIG.TopologyProjection,
          topologyCode: CONFIG.TopologyCode,
          // projectCode: row.project_code,
          // topologyCode: row.topology_code,
          code: row.code,
          reviewStatus: row.reviewStatus,
        }
        
        postAction(this.url.getNodeByCode, params).then((res) => {
          if (res.success) {
            this.model = res.result.node
          } else {
            this.$message.error(res.message)
          }
        }).finally(() => {
          this.confirmLoading = false
        })
      } else {
        // 新增模式：直接显示表单，使用传入的数据
        this.isEdit = false
        this.title = this.$t('新增节点')
        
        // 初始化表单数据
        this.model = {
          projectCode: row.project_code || '',
          topologyCode: row.topology_code || '',
          name: '',
          type: '',
          height: '',
          dmaFlag: false, // 默认为否
          zoomLevel: '',
          x: row.x || '',
          y: row.y || '',
          // 保存管线关联信息（如果在管线上添加）
          pipelineId: row.pipelineId || '',
          pipelineCode: row.pipelineCode || '',
        }
        
        this.confirmLoading = false
      }
    },
    // 设置label
    setLabel(key) {
      return this.fieldLabels[key] || key
    },
    // 设置禁用
    setDisabled(key){
      // 新增模式下，所有字段都可编辑（除了项目编码和拓扑编码）
      if (!this.isEdit) {
        if (key == 'projectCode' || key == 'topologyCode') {
          return true
        }
        return false
      }
      
      // 编辑模式下，编码字段不可编辑
      if (key == 'projectCode' || key == 'topologyCode' || key == 'code') {
        return true
      }
      return false
    },
    // 设置显示隐藏
    setIsShow(key){
      if(this.fieldLabels[key]){
        return true
      }else{
        return false
      }
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleCancel() {
      this.close()
    },
    handleOk() {
      const that = this
      this.$refs.form.validate(valid => {
        if (valid) {
          that.confirmLoading = true
          
          // 根据模式调用不同的接口
          if (this.isEdit) {
            // 编辑模式：根据来源和操作类型选择不同的接�?
            let editUrl
            if (!this.editFromList) {
              // 地图编辑
              editUrl = this.url.updateNode
            } else if (this.operationType === 'updateApply') {
              // 列表更新申请
              editUrl = this.url.updateApply
            } else {
              // 列表编辑草稿
              editUrl = this.url.updateDraft
            }
            
            postAction(editUrl, this.model)
              .then(res => {
                if (res.success) {
                  that.$message.success(this.$t('编辑成功！'))
                  that.$emit('ok')
                  // 如果是从列表打开的编辑，触发列表刷新事件
                  if (that.editFromList) {
                    that.$emit('listRefresh')
                  }
                  this.visible = false
                } else {
                  that.$message.warning(res.message)
                }
              })
              .finally(() => {
                that.confirmLoading = false
              })
          } else {
            // 新增模式：按照后台要求的格式组装数据
            const addNodeParams = {
              newNodeData: {
                projectCode: this.model.projectCode,
                topologyCode: this.model.topologyCode,
                name: this.model.name,
                height: this.model.height ? parseFloat(this.model.height) : 0,
                dmaFlag: this.model.dmaFlag ? 1 : 0, // 布尔值转数字
                type: this.model.type,
                // 构造 geometry：POINT Z(x y z) | 3857
                geometry: `POINT Z(${this.model.x} ${this.model.y} 0) | 3857`
              },
              // 如果在管线上添加，添加关联的管线编码
              newNodeInPipelineCodeList: this.model.pipelineCode 
                ? [this.model.pipelineCode] 
                : []
            }
            
            postAction(this.url.addNode, addNodeParams)
              .then(res => {
                if (res.success) {
                  that.$message.success(this.$t('新增成功！'))
                  that.$emit('ok')
                  this.visible = false
                } else {
                  that.$message.warning(res.message)
                }
              })
              .finally(() => {
                that.confirmLoading = false
              })
          }
        }
      })
    },
  },
}
</script>
